// extracted by mini-css-extract-plugin
export default {"entryRow":"styles_entryRow__QWMi5","invoiceTable":"styles_invoiceTable__bSclM","buttonContainer":"styles_buttonContainer__l53SX","noInvoice":"styles_noInvoice__gIYKr"};